export const listPositionsMap = [
	{ top: 17, left: 73 },
	{ top: 59, left: 82 },
	{ top: 76, left: 73 },
	{ top: 81, left: 51 },
	{ top: 100, left: 42 },
	{ top: 114, left: 27 },
	{ top: 129, left: 18 },
	{ top: 142, left: 27 },
	{ top: 155, left: 35 },
	{ top: 170, left: 40 },
	{ top: 174, left: 64 },
	{ top: 177, left: 84 },
	{ top: 177, left: 104 },
	{ top: 170, left: 124 },
	{ top: 167, left: 141 },
	{ top: 183, left: 124 },
	{ top: 194, left: 112 },
	{ top: 209, left: 110 },
	{ top: 227, left: 107 },
	{ top: 246, left: 104 },
	{ top: 264, left: 97 },
	{ top: 275, left: 83 },
	{ top: 294, left: 75 },
	{ top: 309, left: 87 },
	{ top: 297, left: 101 },
	{ top: 290, left: 119 },
	{ top: 300, left: 135 },
	{ top: 316, left: 150 },
	{ top: 309, left: 176 },
	{ top: 290, left: 187 },
	{ top: 281, left: 205 },
	{ top: 289, left: 225 },
	{ top: 293, left: 245 },
	{ top: 310, left: 249 },
	{ top: 328, left: 259 },
	{ top: 344, left: 274 },
	{ top: 361, left: 284 },
	{ top: 379, left: 282 },
	{ top: 400, left: 281 },
	{ top: 418, left: 287 },
	{ top: 431, left: 298 },
	{ top: 442, left: 310 },
	{ top: 461, left: 316 },
	{ top: 473, left: 331 },
	{ top: 492, left: 325 },
	{ top: 506, left: 337 },
	{ top: 524, left: 341 },
	{ top: 534, left: 344 },
	{ top: 554, left: 341 },
	{ top: 571, left: 338 },
]
